// AUTO-GENERATED FILE - DO NOT EDIT
import * as z from "zod";
import { requestHandler } from "../requestHandler";
import { dateSchema } from "../commonSchemas";

export const path = "update-load-info";

export const updateLoadInfoParamsSchema = z.object({
  id: z.string().uuid(),
  deliveryEta: dateSchema.optional().nullable(),
  receiverCostCents: z.number().optional().nullable(),
  carrierPayCents: z.number().optional().nullable(),
  carrierId: z.string().uuid().optional().nullable(),
  driverName: z.string().optional().nullable(),
  driverLicenseNumber: z.string().optional().nullable(),
  truckLicensePlate: z.string().optional().nullable(),
  truckVinLast6: z.string().optional().nullable(),
  trailerLicensePlate: z.string().optional().nullable(),
  trailerNumber: z.string().optional().nullable(),
  bol: z.string().optional().nullable(),
});




export type UpdateLoadInfoParams = z.infer<typeof updateLoadInfoParamsSchema>;




// broker/update-load-info endpoint
export function updateLoadInfo(
  params: z.input<typeof updateLoadInfoParamsSchema>
): Promise<void> {
  return requestHandler(
    "broker/update-load-info",
    params,
    undefined,
  );
}

